import { Controller, useFormContext } from "react-hook-form";
import TextArea from "./TextArea";
import React from "react";

interface FormTextAreaProps {
  name: string;
  placeholder?: string;
  label?: string;
  description?: string;
  rows?: number;
  disabled?: boolean;
}

const FormTextArea = ({ name, placeholder, label, description, rows, disabled }: FormTextAreaProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextArea
          value={field.value ?? ""}
          onChange={field.onChange}
          placeholder={placeholder}
          label={label}
          description={description}
          rows={rows}
          disabled={disabled}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};

export default FormTextArea;
